import React from 'react'
import jsPDF from 'jspdf';
import { useRef } from 'react';
import { useState, useEffect, useCallback } from "react";
import html2pdf from 'html2pdf.js';

export default function Playerspdf() {
    const canvasRef = useRef(null);
    const contentRef = useRef(null);


    useEffect(() => {

    }, []); // Run the effect only once on mount
    const convertToBase64 = (imageUrl) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = imageUrl;
    
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
    
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
    
            const base64Data = canvas.toDataURL('image/png');
            resolve(base64Data);
            //  console.log(base64Data)
          };
        });
      };
    const imageUrl = 'https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg';
    convertToBase64(imageUrl);

    const generatePDF = async () => {
    const element = contentRef.current;
    
    // Calculate actual content dimensions
    const width = element.offsetWidth;
    const height = element.offsetHeight;
    //  console.log(width)
    //  console.log(height)

    // Create worker
    const worker = html2pdf().set({
      margin: 0,
      filename: 'generated-document.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: {
        scale: 2,
        logging: true,
        dpi: 192,
        letterRendering: true,
        useCORS: true,
      },
      jsPDF: {
        unit: 'px',
        format: [width, height],
        orientation: 'portrait',
        compress: true,
        precision: 16
      }
    });

    try {
      await worker.from(element).save();
    } catch (error) {
      console.error('PDF generation failed:', error);
    }
  };
    return (
        <>
            {/* <div>
                <img id="sourceImage" src="https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg" alt="Your Image" style={{ display: 'none' }} />
                <canvas ref={(ref) => { if (ref) { canvasRef } }} style={{ display: 'none' }}></canvas>
            </div>
             */}
             <div ref={contentRef}  className='testpdfdiv'>
              <h3>Name : Bhupendraaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa</h3>
             </div>
            <button  onClick={generatePDF}>Generate</button>
        </>
    )
}
